export default "__VITE_ASSET__DPNfJPm7__"